import { getCookie } from './getCookie';
import { AppContextEnum, BackendEnvironmentEnum, CookieEnum, DestinationEnum } from './types/enums';
import { PREVENTION_COOKIE_VALUE } from './types/constants';
var allowedContexts = [
    AppContextEnum.digitalbank,
    AppContextEnum.fremtind,
    AppContextEnum.kreditt,
];
export var fetchMissingCookies = function (initParams) {
    if (!shouldFetchCookies(initParams))
        return;
    var shouldFetchWithIdentity = shouldFetchIdentity(initParams);
    if (shouldFetchConsents() || shouldFetchWithIdentity) {
        var consentCookiesApiUrl = buildConsentCookiesApiUrl(initParams);
        fetch("".concat(consentCookiesApiUrl).concat(shouldFetchWithIdentity ? '?withIdentity=true' : ''), {
            headers: {
                'Content-Type': 'application/json;charset=utf-8;',
                Accept: 'application/vnd.sparebank1.v1+json; charset=utf-8',
                credentials: 'same-origin',
            },
        }).then(function (response) {
            if (!response.ok) {
                console.warn('Request to fetch cookies failed');
                setPreventionCookie();
            }
        });
    }
};
var buildConsentCookiesApiUrl = function (initParams) {
    switch (initParams.backendEnvironment) {
        case BackendEnvironmentEnum.Test:
            return 'https://www.test.sparebank1.no/personal/banking/consent/cookies';
        case BackendEnvironmentEnum.Prod:
            return 'https://www.sparebank1.no/personal/banking/consent/cookies';
        default:
            return '/personal/banking/consent/cookies';
    }
};
export var shouldFetchCookies = function (initParams) {
    if (!allowedContexts.includes(initParams.application.context))
        return false;
    return !isPreventionValues(getCookie(CookieEnum.DeclaredId));
};
export var shouldFetchIdentity = function (initParams) {
    var _a;
    if (((_a = initParams.adobe) === null || _a === void 0 ? void 0 : _a.identityCookiesEnabled) != true)
        return false;
    if (!initParams.destinations.includes(DestinationEnum.Adobe))
        return false;
    var adobeAmcv = getCookie(CookieEnum.AdobeAmcv);
    var adobeIdentity = getCookie(CookieEnum.AdobeIdentity);
    return [adobeAmcv, adobeIdentity].includes(null);
};
export var shouldFetchConsents = function () {
    var declaredId = getCookie(CookieEnum.DeclaredId);
    var sb1OptinAuthenticated = getCookie(CookieEnum.Sb1OptinAuthenticated);
    var sb1OptinAuthenticatedV2 = getCookie(CookieEnum.Sb1OptinAuthenticatedV2);
    return [declaredId, sb1OptinAuthenticated !== null && sb1OptinAuthenticated !== void 0 ? sb1OptinAuthenticated : sb1OptinAuthenticatedV2].includes(null);
};
export var isPreventionValues = function (consentCookieValues) {
    if (!consentCookieValues)
        return false;
    return PREVENTION_COOKIE_VALUE === consentCookieValues;
};
export var setPreventionCookie = function () {
    document.cookie = "".concat(CookieEnum.DeclaredId, "=").concat(PREVENTION_COOKIE_VALUE, "; expires=").concat(new Date(new Date().getTime() + 5 * 60 * 1000 // Five minutes
    ).toUTCString(), "; Path=/");
};
//# sourceMappingURL=fetchMissingCookies.js.map